import React from "react";

const Textarea = ({ label, required = false, error, touched, className = "", ...props }) => {
  const hasError = touched && error;
  const textareaId = props.id || props.name || `textarea-${Math.random().toString(36).substr(2, 9)}`;

  return (
    <div className="w-full">
      {label && (
        <label htmlFor={textareaId} className="block text-sm font-medium text-gray-700 mb-2">
          {label} {required && <span className="text-red-500">*</span>}
        </label>
      )}

      <textarea
        id={textareaId}
        className={`w-full px-4 py-3 rounded-lg text-sm text-secondary placeholder-gray-400 
          focus:outline-none focus:ring-2 focus:ring-secondary focus:border-secondary transition-colors resize-none
          ${hasError ? "border-red-300 bg-red-50" : "border-gray-300 bg-grey"} 
          ${className}`}
        {...props}
      />

      {hasError && <p className="mt-1.5 text-xs text-red-600">{error}</p>}
    </div>
  );
};

export default Textarea;




